import { QueryClient } from '@tanstack/react-query'

// Single shared QueryClient for the whole app. Exported as a module singleton
// (rather than created inline in main.tsx) so non-view modules — notably
// AuthContext — can clear the cache on an auth-identity change without reaching
// through the React provider tree via useQueryClient().
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
})
